import './bootstrap';

// Sentry browser SDK initialization for fbr-survey.
//
// Reads its config from `window.sentry*` globals injected by the layout
// (resources/views/inc/head.blade.php). Loaded once per page via @vite.
//
// Session Replay is opt-in via SENTRY_REPLAY_ENABLED. When enabled it
// records DOM mutations and user input so frontend errors can be replayed
// in Sentry. PII masking defaults to ON — survey participants enter
// free-text answers, so we keep maskAllText/blockAllMedia true unless
// legal/PII review approves otherwise.
import * as Sentry from '@sentry/browser';

// Expose Sentry globally for ad-hoc debugging from the browser console.
window.Sentry = Sentry;

if (window.sentryDsn) {
    const sentryConfig = {
        dsn: window.sentryDsn,
        environment: window.sentryEnvironment || 'production',
        tracesSampleRate: parseFloat(window.sentryTracesSampleRate) || 0.1,
    };

    if (window.sentryReplayEnabled) {
        sentryConfig.replaysSessionSampleRate = parseFloat(window.sentryReplaySessionSampleRate) || 0;
        sentryConfig.replaysOnErrorSampleRate = parseFloat(window.sentryReplayErrorSampleRate) || 1.0;
        sentryConfig.integrations = [
            Sentry.replayIntegration({
                maskAllText: window.sentryReplayMaskAllText !== false,
                blockAllMedia: window.sentryReplayBlockAllMedia !== false,
            }),
        ];
    }

    Sentry.init(sentryConfig);
}

// Prevent double form submissions on survey pages.
document.addEventListener('DOMContentLoaded', function () {
    const surveyForms = document.querySelectorAll('form[action*="takesurvey"], form[action*="survey"]');

    surveyForms.forEach(form => {
        let isSubmitting = false;

        form.addEventListener('submit', function (e) {
            if (isSubmitting) {
                e.preventDefault();
                return false;
            }

            isSubmitting = true;

            // Disable all submit buttons in the form
            const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
            submitButtons.forEach(button => {
                button.disabled = true;
                // Store original text and show loading state
                if (button.tagName === 'BUTTON') {
                    button.dataset.originalText = button.innerHTML;
                    button.innerHTML = 'Processing...';
                }
            });

            // Re-enable after 5 seconds as a fallback.
            setTimeout(() => {
                isSubmitting = false;
                submitButtons.forEach(button => {
                    button.disabled = false;
                    if (button.dataset.originalText) {
                        button.innerHTML = button.dataset.originalText;
                    }
                });
            }, 5000);
        });
    });
});
